import React from "react";
import Table from "../components/Table";

import VLButton from "../components/VLButton";
import {useApi, VLScreen2} from "./VLScreen2";

const styleTd = {padding: 8};

const ListItem = ({subcontractor}) => (
    <tr>
        <td style={styleTd}>{subcontractor.email}</td>
        <td style={styleTd}>{subcontractor.name}</td>
    </tr>
);

const List = ({subcontractors}) => (
    <Table fieldNames={["Email", "Name"]}>
        {subcontractors.map(e => <ListItem subcontractor={e}/>)}
    </Table>
);

const Screen = ({subcontractors}) => (
    <div style={{display: "flex", width: "100%", justifyContent: "center", padding: 16, flexDirection: "column", alignItems: "flex-start"}}>
        <VLButton title="Add Subcontractor" href="/subcontractors/-1"/>
        <br/>
        <List subcontractors={subcontractors}/>
    </div>
);

const Container = () => {

    const [loaded, error, data, reload] = useApi("subcontractors/list", {}, []);

    return (
        <VLScreen2 title="Subcontractors" error={error} loaded={loaded} retry={reload}>
            <Screen subcontractors={data.subcontractors}/>
        </VLScreen2>
    );
};

export default Container;